import React from "react"
import { Text } from "dash-styled"
import { TableColumn } from "resha"
import { Customer } from "../../../../../../Models/API/BackofficeModel"
import { format } from "date-fns/esm"

export const customerColumns: TableColumn<Customer>[] = [
    {
        renderHeader: () => "Email",
        render: ({ email }) => {
            return (
                <Text
                    className="m-0 whitespace-no-wrap truncate"
                    weight="semibold"
                    size="sm"
                >
                    {email}
                </Text>
            )
        },
        className: "w-2/12"
    },
    {
        renderHeader: () => "Status",
        render: ({ enabled, deleted }) => {
            return (
                <div className="flex items-center truncate">
                    <Text
                        className={`m-0 whitespace-no-wrap truncate`}
                        size="sm"
                    >
                        {deleted ? "Deleted" : enabled ? "Active" : "Inactive"}
                    </Text>
                </div>
            )
        },
        className: "text-smoke-610",
        headerClassName: "w-1/12"
    },
    {
        renderHeader: () => "Created",
        render: ({ created, deleted }) => {
            return (
                <div className="flex items-center truncate">
                    <Text
                        className={`m-0 whitespace-no-wrap truncate`}
                        size="sm"
                    >
                        {!deleted
                            ? format(new Date(created), "dd.MM.yyyy")
                            : "-"}
                    </Text>
                </div>
            )
        },
        className: "text-smoke-610",
        headerClassName: "w-1/12"
    },
    {
        renderHeader: () => "Account type",
        render: ({ plan, deleted }) => {
            return (
                <div className="flex items-center truncate">
                    <Text
                        className={`m-0 whitespace-no-wrap truncate`}
                        size="sm"
                    >
                        {!deleted ? plan : "-"}
                    </Text>
                </div>
            )
        },
        className: "text-smoke-610",
        headerClassName: "w-1/12"
    },
    {
        renderHeader: () => "Trial days",
        render: ({ trialDays }) => {
            return (
                <div className="flex items-center truncate">
                    <Text
                        className={`m-0 whitespace-no-wrap truncate`}
                        size="sm"
                    >
                        {trialDays === undefined || trialDays === null
                            ? "-"
                            : trialDays}
                    </Text>
                </div>
            )
        },
        className: "text-smoke-610",
        headerClassName: "w-1/12"
    }
]
